import React from 'react';
import './scss/Footer.scss';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; {currentYear} Riyasat. All rights reserved. Built with React, TypeScript & SASS.</p>
      </div>
    </footer>
  );
};

export default Footer;
